import React from "react";
import { Checkbox as AntdCheckbox, type CheckboxProps } from "antd";
import "./style.scss";

interface CustomCheckboxProps extends CheckboxProps {
  customClassName?: string;
}

const Checkbox: React.FC<CustomCheckboxProps> = ({
  children,
  onChange,
  checked,
  customClassName = "",
  ...rest
}) => {
  return (
    <AntdCheckbox
      className={`custom-checkbox ${customClassName}`}
      onChange={onChange}
      checked={checked}
      {...rest}
    >
      {children}
    </AntdCheckbox>
  );
};

export default Checkbox;
